<div class="grid grid-cols-2 h-full">
	<div class="bg-gray-50 flex items-center justify-center">
		<img
			class="max-w-sm"
			src="assets/images/undraw/undraw_compose-email_s6kf.svg"
			alt="Closer's Email Integration"
		/>
	</div>
	<div class="px-8 py-6">
		<h3 class="h3 mb-6">Understanding Closer’s Email Integration</h3>
		<h4 class="h4 mb-4">Send Emails with Closer</h4>
		<ul class="list-disc list-inside">
			<li class="mb-2">Easily connect your mail account to Closer.</li>
			<li class="mb-2">Track emails sent from your account</li>
		</ul>
		<div class="py-6">
			<hr class="border-gray-200" />
		</div>
		<h4 class="h4 mb-4">
			Use Closer’s Email Templates with Client Intake Forms
		</h4>
		<ul class="list-disc list-inside">
			<li class="mb-2">Edit email template with ease</li>
			<li class="mb-2">Easily launch email from the client intake process.</li>
		</ul>
	</div>
</div>
